import { MONTHS } from "@/components/DateFilter";
import { parseDMY } from "@/components/DateInput";

export const STATUS = {
  OPEN: { label: "Tersedia", short: "OPEN", cls: "border-slate-200 bg-white text-slate-700", dot: "bg-slate-300" },
  PB: { label: "Pasti Berangkat", short: "PB", cls: "border-emerald-300 bg-emerald-50 text-emerald-800", dot: "bg-emerald-500" },
  PS: { label: "Push Selling", short: "PS", cls: "border-violet-300 bg-violet-50 text-violet-800", dot: "bg-violet-500" },
  TJ: { label: "Tidak Jalan", short: "TJ", cls: "border-slate-300 bg-slate-100 text-slate-500 line-through", dot: "bg-slate-500" },
  SO: { label: "Sold Out", short: "SO", cls: "border-red-300 bg-red-50 text-red-700", dot: "bg-red-500" },
  CS: { label: "Close Selling", short: "CS", cls: "border-amber-300 bg-amber-50 text-amber-800", dot: "bg-amber-500" },
};

const pad = (n) => String(n).padStart(2, "0");
export const todayISO = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
export const dmyToISO = (s) => { const d = parseDMY(s); return d ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` : null; };
export const isoToDMY = (s) => (s ? `${s.slice(8, 10)} ${s.slice(5, 7)} ${s.slice(0, 4)}` : "");
export const fmtISO = (s) => (s ? `${s.slice(8, 10)} ${MONTHS[Number(s.slice(5, 7)) - 1].slice(0, 3)} ${s.slice(0, 4)}` : "");
export const monthLabel = (key) => `${MONTHS[Number(key.slice(5, 7)) - 1]} ${key.slice(0, 4)}`;

export const activePromos = (p, today = todayISO()) => (p.promos || []).filter((x) => (!x.start || x.start <= today) && (!x.end || x.end >= today));

export const groupByMonth = (deps) => deps.reduce((acc, d) => { (acc[d.date.slice(0, 7)] ||= []).push(d); return acc; }, {});

export const EMPTY_FILTER = { q: "", group: "all", city: "all", status: "all", from: "", to: "", month: "all", year: "all", sort: "nearest" };

export function applyFilters(products, f) {
  const q = f.q.trim().toLowerCase();
  const from = dmyToISO(f.from), to = dmyToISO(f.to), today = todayISO();
  const depFilter = f.status !== "all" || from || to || f.month !== "all" || f.year !== "all";
  const out = [];
  for (const p of products) {
    if (f.group !== "all" && p.group !== f.group) continue;
    if (f.city !== "all" && p.departure_city !== f.city) continue;
    if (q && ![p.name, p.highlight, p.airline, p.group, p.operator, p.departure_city, p.days].some((s) => (s || "").toLowerCase().includes(q))) continue;
    const deps = p.departures.filter((d) => d.date >= today && (f.status === "all" || d.status === f.status) && (!from || d.date >= from) && (!to || d.date <= to)
      && (f.month === "all" || Number(d.date.slice(5, 7)) === Number(f.month)) && (f.year === "all" || d.date.slice(0, 4) === f.year));
    if (depFilter && deps.length === 0) continue;
    out.push({ ...p, shown: deps });
  }
  const first = (p) => p.shown[0]?.date || "9999";
  const sorters = {
    nearest: (a, b) => first(a).localeCompare(first(b)),
    name: (a, b) => a.name.localeCompare(b.name, "id"),
    promo: (a, b) => activePromos(b).length - activePromos(a).length || first(a).localeCompare(first(b)),
  };
  return out.sort(sorters[f.sort]);
}
